export default __webpack_public_path__ + "static/media/Alien.f2165f4c.jpg";